import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

type Props = {
    title: string;
    body: React.ReactNode;
};

export function SupportStack(props: Props) {
    return (
        <StackLegacy spacing={4}>
            <Body as='div' isBold={true}>
                {props.title}
            </Body>
            {props.body}
        </StackLegacy>
    );
}
